import mergeTagModalCreator from '../../../../merge-tags/helpers/merge-tag-modal-creator';

export default class AlEmailTemplateEditorBeefreeModalController {
    constructor($uibModalInstance, $scope, $injector, originalTemplate, guestlistTemplate) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.originalTemplate = originalTemplate;
        this.guestlistTemplate = guestlistTemplate;
        this.templateModel = {
            beefree_json: _.cloneDeep(originalTemplate.beefree_json),
            html: _.cloneDeep(originalTemplate.html)
        }

        this.beefreeEnabled = !!this.originalTemplate.beefree_json;
        this.enableModeChange = this.beefreeEnabled;
        this.beefreeSaveCallback = null;
        this.beefreeReady = false;
        this.aceConfig = {};
        this.injector.get('AceEditor').getEditor((editor) => this.aceConfig = editor);
        this._prepareBeefreeContentDialogs();
    }

    handleBeefreeReady() {
        this.beefreeReady = true;
    }

    changeTemplateMode() {
        if (this.beefreeEnabled) {
            this.enableModeChange = false;
            this._triggerBeefreeSave().then((response) => {
                this.beefreeEnabled = false;
                this.templateModel.beefree_json = null;
                this.templateModel.html = response.html;

                this.scope.$applyAsync();
            });
        } else {
            this.beefreeEnabled = true;
            this.beefreeReady = true;
            this.enableModeChange = true;
        }
    }

    useTemplate() {
        this.submitting = true;
        if (this.beefreeEnabled) {
            this._triggerBeefreeSave().then(({html, json}) => {
                this._saveTemplate(html, json);
            })
        } else {
            this._saveTemplate(this.templateModel.html, null);
        }
    }

    dismiss() {
        this.alert.animatedAlert(
            this.translate.instant('templates.components.al-email-template-editor.alerts.ask-for-cancel-without-saving-changes.title'),
            this.translate.instant('templates.components.al-email-template-editor.alerts.ask-for-cancel-without-saving-changes.content'),
            'attention',
            {
                confirmButtonText: this.translate.instant('templates.components.al-email-template-editor.alerts.ask-for-cancel-without-saving-changes.confirm'),
                cancelButtonText: this.translate.instant('templates.components.al-email-template-editor.alerts.ask-for-cancel-without-saving-changes.cancel')
            },
        ).then(() => {
            this.uibModalInstance.dismiss();
        }).catch(() => {

        });
    }

    _triggerBeefreeSave() {
        return new Promise((resolve, reject) => {
            if (_.isFunction(this.beefreeSaveCallback)) {
                return this.beefreeSaveCallback().then((beefreeResponse) => {
                    resolve(beefreeResponse);
                });
            } else {
                resolve({json: null, html: ''});
            }
        })
    }

    _prepareBeefreeContentDialogs() {
        this.beefreeContentDialogs = {
            mergeTags: {
                label: this.translate.instant('templates.pages.editor.beefree_content_dialogs.merge_tags'),
                handler: (resolve, reject) => {
                    mergeTagModalCreator(this.injector, {
                        guestlistId: this.guestlistTemplate ? this.guestlistTemplate.guestlist_id : null,
                        hideNonGuestlist: !this.originalTemplate.global_template,
                        scopedGuestlists: _.map(this.originalTemplate.guestlist_links, (guestlistTemplate) => {
                            return guestlistTemplate.guestlist_id
                        })
                    })
                        .then((selectedPlaceholder) => {
                            resolve({
                                name: selectedPlaceholder.label,
                                value: selectedPlaceholder.placeholder

                            })
                        })
                        .catch(() => {
                            reject();
                        })
                }
            }
        };
    }

    _saveTemplate(html, json) {
        this.api.put(
            `templates/${this.originalTemplate.id}/template`,
            {
                beefree_json: json ? JSON.parse(json) : null,
                html: html
            }
        ).then(({data}) => {
            this.submitting = false;
            this.uibModalInstance.close({
                json: data.data.beefree_json,
                html: data.data.html
            });
        }).catch(() => {
            this.submitting = false;
        })
    }
}

AlEmailTemplateEditorBeefreeModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'originalTemplate',
    'guestlistTemplate'
]



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-email-template-editor/controllers/beefree-modal-controller.js